import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import {
  SmartlinkParameter,
  smartlinkParameterSchema,
} from '@sophocles/entities/SmartlinkParameter/smartlinkParameterRecord';
import { addToast } from '@sophocles/features/toast';
import apiClient, { vantageApiClient } from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_SMARTLINK_PARAMETERS = 'RECEIVE_SMARTLINK_PARAMETERS';
function receiveSmartlinkParameters(json) {
  return {
    type: RECEIVE_SMARTLINK_PARAMETERS,
    smartlinkParameters: mapListToRecords(json, SmartlinkParameter),
  };
}

/* Request Actions */
// starter request
export const REQUEST_SMARTLINK_PARAMETER = 'REQUEST_SMARTLINK_PARAMETER';
function requestSmartlinkParameter(smartlinkParameter_id) {
  return {
    type: REQUEST_SMARTLINK_PARAMETER,
    smartlinkParameter_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchSmartlinkParameter(smartlinkParameter_id) {
  return dispatch => {
    dispatch(requestSmartlinkParameter(smartlinkParameter_id));
    return apiClient
      .get(`/relaycontrollerparameters/${smartlinkParameter_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'smartlinkParameters', smartlinkParameterSchema))
      .then(json => dispatch(receiveSmartlinkParameters(json.entities.smartlinkParameters)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SMARTLINK_PARAMETER)));
  };
}

export function fetchSmartlinkParameterForRelayController(relayController_id) {
  const url = `/relaycontrollerparameters/?relay_controller=${relayController_id}`;

  return dispatch => {
    dispatch(requestSmartlinkParameter(relayController_id));
    return apiClient
      .get(url)
      .then(checkHttpStatus)
      .then(response => {
        const normalized = normalizeList(response.data.results, 'smartlinkParameters', smartlinkParameterSchema);
        dispatch(receiveSmartlinkParameters(normalized.entities.smartlinkParameters));
        return response.data;
      })
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SMARTLINK_PARAMETER)));
  };
}

export function fetchSmartlinkParameterForRelayControllerVantage(relayController_id) {
  const url = `/unit/configparams/${relayController_id}/`;

  return dispatch =>
    vantageApiClient
      .get(url)
      .then(checkHttpStatus)
      .then(response => response.data)
      .then(res => {
        return res;
      })
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SMARTLINK_PARAMETER)));
}

/* Edit Actions */
export const EDIT_SMARTLINK_PARAMETER = 'EDIT_SMARTLINK_PARAMETER';
export function editSmartlinkParameter(smartlinkParameter_id) {
  return {
    type: EDIT_SMARTLINK_PARAMETER,
    smartlinkParameter: smartlinkParameter_id,
  };
}

export function patchSmartlinkParameter(smartlinkParameter_id, values, isVantage) {
  let url = `/relaycontrollerparameters/${smartlinkParameter_id}/`;
  if (isVantage) {
    url = `/unit/configparams/${smartlinkParameter_id}/`;
  }
  const client = isVantage ? vantageApiClient : apiClient;

  return dispatch => {
    dispatch(editSmartlinkParameter(smartlinkParameter_id));
    return client
      .patch(url, values)
      .then(checkHttpStatus)
      .then(response => {
        const normalized = normalizeList([response.data], 'smartlinkParameters', smartlinkParameterSchema);
        dispatch(receiveSmartlinkParameters(normalized.entities.smartlinkParameters));
        dispatch(
          addToast({
            title: 'Success',
            message: 'Parameters Updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return response.data;
      })
      .catch(error => dispatch(genericErrorAction(error, EDIT_SMARTLINK_PARAMETER)));
  };
}

/* Create Actions */
export const CREATE_SMARTLINK_PARAMETER = 'CREATE_SMARTLINK_PARAMETER';
function sayCreateSmartlinkParameter(values) {
  return {
    type: CREATE_SMARTLINK_PARAMETER,
    values: values,
  };
}

export function createSmartlinkParameter(values) {
  return dispatch => {
    dispatch(sayCreateSmartlinkParameter(values));
    return apiClient
      .post(`/relaycontrollerparameters/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, smartlinkParameterSchema))
      .then(json => dispatch(receiveSmartlinkParameters(json.entities.smartlinkParameters)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_SMARTLINK_PARAMETER)));
  };
}

/* Delete Actions */
export const DELETE_SMARTLINK_PARAMETER = 'DELETE_SMARTLINK_PARAMETER';
function sayDeleteSmartlinkParameter(smartlinkParameter_id) {
  return {
    type: DELETE_SMARTLINK_PARAMETER,
    smartlinkParameter: smartlinkParameter_id,
  };
}

export function deleteSmartlinkParameter(smartlinkParameter_id) {
  return dispatch =>
    apiClient
      .delete(`/relaycontrollerparameters/${smartlinkParameter_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteSmartlinkParameter(smartlinkParameter_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_SMARTLINK_PARAMETER)));
}

const smartlinkParameterReceiver = (dispatch, json) => {
  return dispatch(receiveSmartlinkParameters(json.entities.smartlinkParameters));
};

export const handleSmartlinkParameterActions = websocketsHandlerFactory(
  smartlinkParameterReceiver,
  sayDeleteSmartlinkParameter,
  smartlinkParameterSchema,
);
